import "./scroll-mask.css";
import { ScrollMask } from './scroll-mask';
export default ScrollMask;